/* Built In Imports */
import NextLink from 'next/link';

/* External Imports */
import { Box, Flex, Link } from '@chakra-ui/react';
/* Internal Imports */
/* Component */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import { refineUrlDomain } from '@components/Utility/utils';
import config from '@config';

/* Styles */
/* Services */
/**
 * Renders DownloadTheApp Component
 * @param {Object} sectionContent - Data for the section
 * @param {string} region - Region for the Section
 * @param {string} lang - Language for the Section
 * @returns  {ReactElement} - DownloadTheApp Component
 */
const DownloadTheApp = ({ sectionContent, region, lang }) => {
  // consoleLog(sectionContent, 'data for the banner');
  return (
    // Maxwidth for the component
    <Box maxW={'1300px'} mx={{ base: '0', lg: 'auto', md: '15px' }}>
      {/* Background Layout for the component */}
      <Box
        width="100%"
        background="#f5f0e5"
        px="calc((100% - 1024px)/2)"
        pt="90px"
        pb="68px"
      >
        {/* Here comes the content of the page */}
        <Flex
          flexDirection={{ base: 'column', md: 'row' }}
          className="content"
          alignItems={{ base: 'center', md: 'normal' }}
          justifyContent={{ base: 'center', md: 'normal' }}
          px="15px"
        >
          <Flex
            flexDir={'column'}
            flex={1}
            alignItems={{ base: 'center', md: 'normal' }}
            justifyContent={{ base: 'center', md: 'normal' }}
          >
            <Box
              w={'100%'}
              fontFamily="'FedraSansStd-medium', sans-serif"
              fontSize={{ base: '28px', md: '40px' }}
              color="#351f15"
              lineHeight="1.17"
              marginBottom="20px"
              textAlign={{ md: 'left', base: 'center' }}
            >
              {sectionContent[0].text}
            </Box>

            <Flex w={'100%'}>
              <NextLink
                href={refineUrlDomain(sectionContent[1]?.linkUrl, region, lang)}
                passHref
                legacyBehavior>
                <Link maxW={200} flex={1} marginRight="10px" width={'45%'}>
                  <LazyLoadImageComponent
                    w="100%"
                    objectFit={'cover'}
                    alt="Download the app"
                    title="Download the app"
                    src={`${config.imgPath}/d/46272/1663652244-android.jpg`}
                    // src="https://isha.sadhguru.org/profiles/isha/themes/ishatheme/sadhguruapp/images/android.jpg"
                  />
                </Link>
              </NextLink>
              <NextLink
                href={refineUrlDomain(sectionContent[2]?.linkUrl, region, lang)}
                passHref
                legacyBehavior>
                <Link flex={1} w="45%" maxW={200}>
                  <LazyLoadImageComponent
                    w="100%"
                    objectFit={'cover'}
                    alt="Download the app"
                    title="Download the app"
                    src={`${config.imgPath}/d/46272/1663652344-apple.jpg`}
                    // src="https://isha.sadhguru.org/profiles/isha/themes/ishatheme/sadhguruapp/images/apple.jpg"
                  />
                </Link>
              </NextLink>
            </Flex>
            <Box
              fontFamily="'FedraSansStd-book', sans-serif"
              fontSize={{ base: '18px', md: '30px' }}
              color="#050505"
              lineHeight="1.33"
              textAlign={{ base: 'center', md: 'left' }}
              marginTop="50px"
            >
              {sectionContent[3].text}
            </Box>
          </Flex>

          <Flex
            flex={1}
            alignItems="center"
            justifyContent={'center'}
            mt={{ base: '32px', md: '0' }}
          >
            <Box
              width={{ base: '100%', md: '373px' }}
              textAlign="center"
              padding="30px 55px 27px 55px"
              borderRadius="8px"
              border="solid 1px #e9dcbe"
              backgroundColor="#ffffff"
            >
              <LazyLoadImageComponent
                // src={`${config.imgPath}/profiles/isha/themes/ishatheme/sadhguruapp/images/qrcode_new.jpg`}
                src={sectionContent[5].image.url}
                alt="qr Code"
                title="QR code"
                objectFit={'cover'}
                w="100%"
              />
              <Box
                fontFamily="'FedraSansStd-medium', sans-serif"
                fontSize={{ base: '15px', md: '24px' }}
                color="#000000"
                marginTop="10px"
                as={'p'}
              >
                {sectionContent[4].text}
              </Box>
            </Box>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default DownloadTheApp;
